import { subDays } from 'date-fns'

import { PAYMENT_DATE_DAYS_BEFORE_DELIVERY } from '@mindfulchefuk/constants'

export default function getPaymentDate(deliveryDate: string | Date): Date {
  return subDays(deliveryDate, PAYMENT_DATE_DAYS_BEFORE_DELIVERY)
}
